import _ from 'lodash'

import { resolvePlayableActivities } from '@/shared/level-play/activityPlayability'
import { hasIntro } from '@/shared/level-play/hasIntro'

import { KINDS as CHALLENGE_KINDS } from '../Questions/config'

/**
 * Perguntas que a execução consegue montar, e as que ela pula com motivo.
 *
 * A regra é do motor (`shared/level-play/activityPlayability`) — antes vivia
 * aqui como um `filter` por kind conhecido, duplicado na jornada e sem contagem.
 */
export const getPlayability = questions =>
  resolvePlayableActivities({
    activities: questions,
    knownKinds: Object.values(CHALLENGE_KINDS)
  })

export const getSteps = questions => {
  const { playable: activeQuestions } = getPlayability(questions)
  let introQuestions = [
    ...activeQuestions.filter(question => hasIntro(question))
  ]
  let steps = []
  steps.push({
    id: 'step-initial',
    kind: CHALLENGE_KINDS.INITIAL,
    position: 0,
    isInitial: true
  })
  steps.push(
    ...introQuestions.map(step => ({
      id: `step-${step.id}-intro`,
      uid: step.uid,
      activityId: step.id,
      kind: CHALLENGE_KINDS.INTRO,
      position: step.position,
      isIntro: true
    }))
  )

  activeQuestions.forEach(step => {
    const kind = step.kind

    if (kind == CHALLENGE_KINDS.SLIDE) {
      const slides = _.get(step, 'meta.slides', [])
      const slideSteps = slides.map((slide, index) => ({
        id: `step-${step.id}-slide-${index + 1}`,
        uid: step.uid,
        activityId: step.id,
        kind: step.kind,
        position: step.position,
        hasIntro: hasIntro(step),
        isSlide: true,
        isFirstSlide: index === 0,
        slideIndex: index,
        isLastSlide: index === slides.length - 1
      }))

      steps.push(...slideSteps)
    } else {
      steps.push({
        id: `step-${step.id}`,
        uid: step.uid,
        activityId: step.id,
        kind: step.kind,
        position: step.position,
        hasIntro: hasIntro(step)
      })
    }
  })

  steps = _.orderBy(
    steps,
    ['isInitial', 'position', 'activityId', 'isIntro'],
    ['asc', 'asc', 'asc']
  )

  return steps
}
